import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DokladCiselnaRada = {
	name: NAME,
	apiProvider,
	router,
};
